import Vue from 'vue';
import Hub from '../hub.js';
import DateFormatter from '../utils/date-formatter.js';
import EventDelegate from '../utils/event-delegate.js';
import CouponModalCompontent from '../components/coupons/coupon-modal-component.vue';

const CouponButton = (() => {

    const TrackAction = {
        CLOSE: {
            Grafana: 'CouponComponent.CloseClick',
            GA: 'click_close'
        },
        OPEN: {
            Grafana: 'CouponComponent.OpenClick',
            GA: 'click_open'
        },
        CONDITIONS: {
            Grafana: 'CouponComponent.ConditionsClick',
            GA: 'click_conditions'
        },
        REDIRECT: {
            Grafana: 'CouponComponent.RedirectClick',
            GA: 'click_redirect'
        }
    };

    const container = document.querySelector('.js-main');

    class CouponButton {
        /**
         * @param {HTMLElement} element
         */
        constructor(element) {
            this.mounted = false;
            const delegate = new EventDelegate(document);
            delegate.on('click', '.js-coupon-button', this.handleClick.bind(this));
        }

        /**
         * Create HTMLElementDiv in body
         * @returns {HTMLElement}
         */

        createDomElement() {
            const element = document.createElement('div');
            document.body.appendChild(element);

            return element;
        }

        /**
         * Create Vue Element
         * @returns {VueComponent}
         */

        createComponent() {
            const _this = this;

            const vm = new Vue({
                render(h) {
                    const _vm = this;

                    return h(CouponModalCompontent, {
                        props: {
                            show: _vm.show,
                            model: _vm.model
                        },
                        on: {
                            close() {
                                _vm.show = false;
                                _this.track(TrackAction.CLOSE, _vm.model.code);
                            },
                            more(isOpen) {
                                isOpen && _this.track(TrackAction.CONDITIONS, _vm.model.code);
                            },
                            copy() {
                                _this.track(TrackAction.REDIRECT, _vm.model.code);
                            }
                        }
                    });
                },
                data: {
                    show: false,
                    model: null
                }
            });

            return vm;
        }

        /**
         * Track events
         * @param {trackAction} - trackAction object
         * @param {code} - code
         */

        track(trackAction, code) {
            Hub.publish(Hub.TRACK_GRAFANA, trackAction.Grafana);
            DM.Utils.trackEvents('coupon_code', trackAction.GA, code);
        }

        /**
         * Mount Vue Element to DOM
         */

        mountComponent() {
            this.mounted = true;
            this.el = this.createDomElement();
            this.vm = this.createComponent();
            this.vm.$mount(this.el);
        }

        /**
         * Click / Touch handler
         * @param {Event} event
         */

        handleClick(event) {
            const element = event.currentTarget;
            const data = {
                id: parseInt(element.dataset.couponId),
                url: element.dataset.couponUrl,
                productId: element.dataset.productId
            };

            !this.mounted && this.mountComponent();
            this.vm.show = !this.vm.show;

            DM.Service.Coupon.getCoupon(data.id, data.productId).then((res) => {
                this.vm.model = Object.assign(data, res);
                this.track(TrackAction.OPEN, this.vm.model.id);
                this.trackFacebook(data.productId, res);
            }).catch(() => {
                this.vm.show = false;
            });

            event.originalEvent.preventDefault();
        }

        handleProductResponse(model) {
            const formatter = new DateFormatter();
            const time = formatter.dateToDMY(new Date(model.validTo));
            const parameters = {
                content_type: 'product',
                discount: model.value,
                price: model.price.promo,
                currency: 'PLN',
                value: 0.00,
                content_ids: model.productId,
                product_name: model.title,
                time: time,
                is_discounted: model.discount != null,
                dada: model.shopId,
                couponcode_id: model.id
            };

            if (window.fbq) {
                window.WP.push(function () {
                    window.WP.gdpr.runAfterConsent(function () {
                        if (window.WP.gdpr.check('mr', 'TP')) {
                            window.fbq('trackCustom', 'CouponCode', parameters);
                        }
                    });
                });
            }
        }

        trackFacebook(productId, coupon) {
            DM.Service.Product.getProduct(productId).then((res) => {
                let model = { productId };
                model = Object.assign(model, coupon, res);
                this.handleProductResponse(model);
            });
        }
    }

    return new CouponButton(container);

})();

export default CouponButton;
